import React, {useEffect, useState} from 'react';
import { FiArrowUpRight, FiMic, FiMicOff, FiPhoneOff, FiUsers } from 'react-icons/fi';
import { BsClipboardCheck, BsKeyboard } from 'react-icons/bs';
import { HiOutlinePause } from 'react-icons/hi2';
import { LuNotebookPen } from 'react-icons/lu';
import { interactions } from '../ctiData';
import { formatSeconds } from '../ctiHelpers';

function OnCallScreen({ holdOn, muteOn, onToggleHold, onToggleMute, onGoConference, campaigns, screen, onReject }) {
  const [callStartTime, setCallStartTime] = useState(null);
  const [callSeconds, setCallSeconds] = useState(0);

  useEffect(() => {
    let timer;

    if (screen === "oncall") {
      if (!callStartTime) {
        setCallStartTime(Date.now());
      }

      timer = setInterval(() => {
        setCallSeconds(Math.floor((Date.now() - callStartTime) / 1000));
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [screen, callStartTime]);

  useEffect(() => {
    if (screen !== "oncall") {
      setCallStartTime(null);
      setCallSeconds(0);
    }
  }, [screen]);
  
  // Safely get the first campaign (most recent/active one) and its script
  const currentCampaign = campaigns && campaigns.length > 0 ? campaigns[0] : {};
  const scriptData = currentCampaign.script || {
    title: null,
    short_description: null,
    description: null,
  };

  return (
    <div className="screen active">
      <div className="oncall-layout">
        <div className="panel" style={{marginRight: '5px'}}>
          <div className="call-header">
            <div className="caller-mini-avatar">A1</div>
            <div className="flex-1">
              <div className="caller-name-sm">Agent 1</div>
              <div className="caller-num-sm">+91 XX43 - Mortgage Refinance Q1</div>
            </div>
            <div className={`call-timer ${holdOn ? 'hold' : ''}`}>{formatSeconds(callSeconds)}</div>
          </div>
          <div className="ctrl-grid">
            <button type="button" className={`ctrl-btn ${holdOn ? 'active-hold' : ''}`} onClick={onToggleHold}>
              <span className="ctrl-icon"><HiOutlinePause /></span>
              <span className="ctrl-label hold" class="ctrl-label hold" id="hold">{holdOn ? 'Unhold' : 'Hold'}</span>
            </button>
            <button type="button" className={`ctrl-btn ${muteOn ? 'active-mute' : ''}`} onClick={onToggleMute}>
              <span className="ctrl-icon">{muteOn ? <FiMicOff /> : <FiMic />}</span>
              <span className="ctrl-label mute" class="ctrl-label mute" id="mute">{muteOn ? 'Unmute' : 'Mute'}</span>
            </button>
            <button type="button" className="ctrl-btn" onClick={onGoConference}>
              <span className="ctrl-icon"><FiUsers /></span>
              <span className="ctrl-label">Conference</span>
            </button>
            <button type="button" className="ctrl-btn">
              <span className="ctrl-icon"><FiArrowUpRight /></span>
              <span className="ctrl-label">Transfer</span>
            </button>
            <button type="button" className="ctrl-btn">
              <span className="ctrl-icon"><BsClipboardCheck /></span>
              <span className="ctrl-label">Wrap Code</span>
            </button>
            <button type="button" className="ctrl-btn">
              <span className="ctrl-icon"><LuNotebookPen /></span>
              <span className="ctrl-label">Note</span>
            </button>
            <button type="button" className="ctrl-btn">
              <span className="ctrl-icon"><BsKeyboard /></span>
              <span className="ctrl-label">DTMF</span>
            </button>
            <button type="button" className="ctrl-btn danger-btn" onClick={onReject}>
              <span className="ctrl-icon"><FiPhoneOff /></span>
              <span className="ctrl-label">End Call</span>
            </button>
          </div>
          <div className="interactions-wrap">
            <div className="subhead">Last 5 Interactions</div>
            {interactions.map((item) => (
              <div className="hist-item" key={item.date}>
                <div className="hist-header">
                  <span className="hist-date">{item.date}</span>
                  <span className="hist-duration">{item.duration}</span>
                </div>
                <span className={`hist-outcome ${item.className}`}>{item.outcome}</span>
                <div className="hist-note">{item.note}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ==================== DYNAMIC CALL SCRIPT PANEL ==================== */}
        <div className="panel" style={{marginRight: '5px'}}>
          <div className="panel-header">
            <span className="panel-title">Call Script</span>
            <span className="script-chip">
              {scriptData.title || currentCampaign.campaign_name || 'No Script Assigned'}
            </span>
          </div>

          <div className="script-wrap">
            {/* Structured dynamic blocks using ALL available data from the campaign + script */}
            <div className="script-block">
              <span className="script-tag">Campaign Name</span>
              {currentCampaign.campaign_name || 'N/A'}
            </div>

            {scriptData.title && (
              <div className="script-block">
                <span className="script-tag">Script Title</span>
                {scriptData.title}
              </div>
            )}

            {scriptData.short_description && (
              <div className="script-block">
                <span className="script-tag">Short Description</span>
                {scriptData.short_description}
              </div>
            )}

            {scriptData.description && (
              <div className="script-block">
                <span className="script-tag">Full Script Content</span>
                <div
                  dangerouslySetInnerHTML={{
                    __html: scriptData.description || '<p>No detailed script available.</p>',
                  }}
                />
              </div>
            )}

            <div className="script-block">
              <span className="script-tag">Start Date</span>
              {currentCampaign.start_date || 'N/A'}
            </div>

            <div className="script-block">
              <span className="script-tag">End Date</span>
              {currentCampaign.end_date || 'N/A'}
            </div>

            {currentCampaign.locations && currentCampaign.locations.length > 0 && (
              <div className="script-block">
                <span className="script-tag">Location</span>
                {currentCampaign.locations[0].location_name}
              </div>
            )}

            <div className="script-block">
              <span className="script-tag">Total Numbers</span>
              {currentCampaign.total_nos || '0'}
            </div>

            {/* Keep the original compliance note at the bottom */}
            <div className="compliance-note">
              <div className="script-tag">Compliance Note</div>
              <div className="tiny-copy">
                Call recorded for QA. Do not make promises outside official rate card. Rates valid until March 31, 2026.
              </div>
            </div>
          </div>
        </div>

        {/* <div className="stack-col">
          <div className="panel fill-panel">
            <div className="panel-header">
              <span className="panel-title">AI Copilot</span>
              <span className="live-chip">LIVE</span>
            </div>
            <div className="ai-wrap">
              <div className="ai-hint">
                <div className="ai-tag">Conversion Signal</div>
                <div className="ai-text">
                  Customer mentioned <strong>EMI review</strong> in last call. Lead in closing stage - use{' '}
                  <strong>urgency framing</strong> around month-end offer.
                </div>
              </div>
              <div className="ai-hint">
                <div className="ai-tag">Product Match</div>
                <div className="ai-text">
                  Based on Rs. 45L loan and 782 credit score, she qualifies for{' '}
                  <strong>Smart Home Flexi Plan</strong> at 8.25% - not yet offered.
                </div>
              </div>
              <div className="ai-hint amber-ai">
                <div className="ai-tag amber-text">Sentiment Alert</div>
                <div className="ai-text">
                  Previous notes show <strong>price sensitivity</strong>. Avoid mentioning fees early. Lead with
                  monthly savings figure.
                </div>
              </div>
              <div className="ai-hint green-ai">
                <div className="ai-tag green-text">Recommended Next Step</div>
                <div className="ai-text">
                  Offer to send <strong>EMI comparison table via WhatsApp</strong> while on call. 73% conversion lift
                  for this segment.
                </div>
              </div>
              <div className="ai-hint">
                <div className="ai-tag">Similar Conversions</div>
                <div className="ai-text">
                  Agents who offered <strong>home documentation pickup</strong> saw 2.4x higher close rate with this
                  customer profile this month.
                </div>
              </div>
            </div>
          </div>

          <div className="panel">
            <div className="panel-header">
              <span className="panel-title">Customer Snapshot</span>
            </div>
            <div className="snapshot-wrap">
              <div className="crm-field">
                <span className="crm-key">Loan Ask</span>
                <span className="crm-val blue">Rs. 45,00,000</span>
              </div>
              <div className="crm-field">
                <span className="crm-key">Credit Score</span>
                <span className="crm-val green">782 up</span>
              </div>
              <div className="crm-field">
                <span className="crm-key">Lead Score</span>
                <span className="crm-val amber">HOT 91/100</span>
              </div>
              <div className="crm-field">
                <span className="crm-key">Preferred Time</span>
                <span className="crm-val">Afternoon</span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default React.memo(OnCallScreen);